<div
  class="star-item"
  role="button"
  tabindex="0"
  [attr.aria-label]="'Edit star: ' + item.name"
  (click)="edit.emit()"
  (keyup.enter)="edit.emit()"
>

  <!-- Score badge: 8-pointed gold star with value overlaid -->
  <div class="star-item__badge" aria-hidden="true">
    <img class="star-item__badge-icon" src="assets/icons/icon-star-badge.svg" alt="" />
    <span class="star-item__badge-value">{{ item.stars }}</span>
  </div>
  <span class="sr-only">Score: {{ item.stars }}</span>

  <!-- Name + tags -->
  <div class="star-item__content">
    <p class="star-item__name">{{ item.name }}</p>
    <div class="star-item__tags" *ngIf="item.selectedTags?.length">
      <app-categories-and-tags-display
        [tags]="item.selectedTags"
        [selectedTags]="item.selectedTags"
      ></app-categories-and-tags-display>
    </div>
  </div>

</div>

<!-- Delete — sits outside the parchment card, to the right -->
<button
  *ngIf="showDeleteIcon"
  type="button"
  class="star-item__delete"
  aria-label="Delete star"
  (click)="$event.stopPropagation(); delete.emit()"
>
  <svg-icon src="assets/icons/icon-trash.svg" class="evergreen" [svgStyle]="{ 'width.px': 10, 'height.px': 11 }"></svg-icon>
</button>
